import React from "react";
import { useSponsors } from "../hooks/useSponsors";
import "./SponsorsPage.css";
import Hero from "../components/Hero";
import LoadingSpinner from "../components/LoadingSpinner";

const SponsorsPage: React.FC = () => {
  const { data: sponsors, loading, error } = useSponsors();

  const sponsorsList = sponsors || [];
  const tiers = Array.from(
    new Map(
      sponsorsList
        .filter((sponsor) => sponsor.tier?.contentfulId)
        .map((sponsor) => [sponsor.tier.contentfulId, sponsor.tier]),
    ).values(),
  ).sort(
    (a, b) =>
      (a.order ?? Number.MAX_SAFE_INTEGER) -
      (b.order ?? Number.MAX_SAFE_INTEGER),
  );

  return (
    <>
      <Hero page="sponsors" titleTwo="Our Sponsors" />
      <main className="sponsors-page-container content-container">
        {loading && <LoadingSpinner />}
        {error && <p className="sponsors-state">Error: {error}</p>}

        {!loading && !error && tiers.length === 0 && (
          <p className="sponsors-state">No sponsors published yet.</p>
        )}

        {!loading &&
          !error &&
          tiers.map((tier) => {
            const tierSponsors = sponsorsList.filter(
              (sponsor) => sponsor.tier?.contentfulId === tier.contentfulId,
            );

            return (
              <section key={tier.contentfulId} className="logos-container">
                <div className="sponsor-tier-heading">
                  <h3>{tier.title}</h3>
                  {tier.description && (
                    <p className="tier-description">{tier.description}</p>
                  )}
                </div>
                <div className="logos-flex-container">
                  {tierSponsors.map((sponsor) => {
                    const logo = (
                      <img
                        src={sponsor.logoUrl}
                        alt={`${sponsor.name} logo`}
                        className="sponsor-img"
                      />
                    );

                    return sponsor.websiteUrl ? (
                      <a
                        key={sponsor.contentfulId}
                        href={sponsor.websiteUrl}
                        target="_blank"
                        rel="noreferrer noopener"
                        className="sponsor-link sponsor-item"
                      >
                        {logo}
                      </a>
                    ) : (
                      <div key={sponsor.contentfulId} className="sponsor-item">
                        {logo}
                      </div>
                    );
                  })}
                </div>
              </section>
            );
          })}
      </main>
    </>
  );
};

export default SponsorsPage;
